export default {"src":"/_next/static/media/drag-and-drop-mini.f8fbb591.svg","height":24,"width":24};